import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	MatCheckboxModule,
	MatFormFieldModule,
	MatIconModule,
	MatInputModule,
	MatSelectModule,
	MatTreeModule,
	MatButtonModule
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { BillModule } from '../bill/bill.module';
import { RoleComponent } from './role.component';

@NgModule({
	declarations: [RoleComponent],
	imports: [
		CommonModule,
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatIconModule,
		MatSelectModule,
		MatTreeModule,
		MatButtonModule,
		FormsModule,
		BillModule,
		RouterModule.forChild([
			{
				path: '**',
				component: RoleComponent,
				data: SaveStateData
			}
		])
	]
})
export class RoleModule {}
